module.exports = __webpack_public_path__ + "img/icon_over_manejo_tablas_meta.7bd3cbe3.svg";